import React from 'react';
import {Route} from 'react-router-dom';
import AsyncDetail from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <Route
    key="/:type(business)/news/detail/:id?"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'news_title',
            item: '/business/news/detail',
          },
        ]}
      />
    }
  >
    <Route path="business/news/detail/:id?" element={<AsyncDetail />} />
  </Route>,
  <Route
    key="/:type(business)/news/:newsHandle?"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'news_title',
            item: '/business/news',
          },
        ]}
      />
    }
  >
    <Route path="business/news/:newsHandle?" element={<AsyncDetail />} />
  </Route>,
  <Route
    key="/:type(business)/news/preview/:id?"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'news_title',
            item: '/business/news/preview',
          },
        ]}
      />
    }
  >
    <Route path="business/news/preview/:id?" element={<AsyncDetail />} />
  </Route>,
];
